<template>
  <v-row>
    <v-col>
      <h1>home</h1>
      <!-- <ClientSelector /> -->
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

// import ClientSelector from "@/components/client/ClientSelector.vue";
// import { mapGetters } from "vuex";

export default {
  name: "home"
};
</script>
